import request from './NetworkLayer';

export default function kinesisPutRecord({ data, partitionKey }) {
  const body = JSON.stringify({
    PartitionKey: partitionKey,
    Data: data
  });
  // return false;
  return request(
    '/streams/lyearn-datasync-stream/recordv3',
    {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        session_token: window.userSessionId
      },
      body
    },
    {
      removeApiEndpoint: true,
      dontAppendApiEndpointQS: true,
      doNotLogoutOn403: true
    }
  );
}
